import React from 'react'
import './section3.css'
import {
    FaLayerGroup,
    FaEye,
    FaRocket,
    FaHandshake,
} from 'react-icons/fa'

const diferenciais = [
    {
        Icon: FaLayerGroup,
        titulo: 'Arquitetura Limpa',
        texto:
            'Cada projeto é construído com código bem documentado, modular e escalável. Facilitamos a manutenção, reduzimos dívida técnica e garantimos evolução contínua do sistema.',
    },
    {
        Icon: FaEye,
        titulo: 'Transparência Total',
        texto:
            'Você acompanha cada etapa do projeto em tempo real. Sem surpresas, sem ambiguidades. Relatórios claros, comunicação direta e entregas validadas pelo cliente.',
    },
    {
        Icon: FaRocket,
        titulo: 'Foco em Escalabilidade',
        texto:
            'Pensamos a longo prazo. Nossas soluções crescem junto com o seu negócio, evitando retrabalho caro e garantindo performance mesmo sob alta demanda.',
    },
    {
        Icon: FaHandshake,
        titulo: 'Parceria de Longo Prazo',
        texto:
            'Não entregamos e sumimos. Oferecemos suporte pós-go-live, sustentação e evolução contínua — porque o sucesso do cliente é o nosso maior resultado.',
    },
]

export default function Section3() {
    return (
        <div id="section3" className="container-fluid">
            <div className="container">

                <div className="section3-header" data-aos="fade-up">
                    <label className="tituloSection d-flex justify-content-center">Por que a Oxfield</label>
                    <p className="subTituloSection mt-3">
                        O que nos torna a escolha certa para o seu negócio
                    </p>
                    <p className="textoSection mt-3" style={{ textAlign: 'center' }}>
                        Combinamos expertise técnica, processos ágeis e compromisso genuíno com resultados —
                        entregando soluções que realmente funcionam no mundo real.
                    </p>
                </div>

                <div className="dif-grid">
                    {diferenciais.map(({ Icon, titulo, texto }, i) => (
                        <div key={i} className="dif-card" data-aos="fade-up">
                            <div className="dif-icon-wrap">
                                <Icon />
                            </div>
                            <p className="dif-titulo">{titulo}</p>
                            <p className="dif-texto">{texto}</p>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    )
}
